export enum TipoProduto_E_OperadoraEnum {
  SAUDE = 1,
  ODONTO = 2,
  UNIMEDFESP_SAUDE = 3,
  UNIODONTO = 4,
  ODONTOPREV = 5,
  UNIMED_ODONTO = 6,
  UDEMO_SAUDE = 7,
  MEDSENIOR = 8,
}

const operadorasData = new Map<TipoProduto_E_OperadoraEnum, any>([
  [
    TipoProduto_E_OperadoraEnum.ODONTOPREV,
    {
      nome: 'OdontoPrev S.A.',
      cnpj: '58119199000151',
      registroAns: '30194-9',
      site: 'www.odontoprev.com.br',
      telefone: '(11) 3883-4483 (de Segunda a Sexta, das 08h00 às 20h00)',
      logo: '../../../../../../assets/app-assets/images/documentos-header/odontoprev.png',
      logoAditivo: '../../../../../../assets/app-assets/images/documentos-header/odontoprev-3-itens-header.png',
      logoInclusaoDependente:
        '../../../../../../assets/app-assets/images/documentos-header/odontoprev-inclusao-dependente.png',
      tipo: TipoProduto_E_OperadoraEnum.ODONTOPREV,
    },
  ],
  [
    TipoProduto_E_OperadoraEnum.UNIODONTO,
    {
      nome: 'UNIODONTO Paulista',
      cnpj: '96396395000162',
      registroAns: '361593',
      site: 'www.uniodontopaulista.com.br',
      telefone: '(11) 3125-3040, (de Segunda a Sexta, das 08h00 às 20h00)',
      logo: '../../../../../../assets/app-assets/images/logos-empresas/uniodonto-planos-odontologicos.png',
      logoAditivo: '../../../../../../assets/app-assets/images/documentos-header/uniodonto-3-itens-header.png',
      logoInclusaoDependente:
        '../../../../../../assets/app-assets/images/documentos-header/uniodonto-inclusao-dependente.png',
      tipo: TipoProduto_E_OperadoraEnum.UNIODONTO,
    },
  ],
  [
    TipoProduto_E_OperadoraEnum.UNIMED_ODONTO,
    {
      nome: 'Unimed Saúde e Odonto S/A',
      cnpj: '10414182000109',
      registroAns: '41.680-1',
      site: 'www.unimedodonto.com.br',
      telefone: '',
      logo: '../../../../../../assets/app-assets/images/documentos-header/unimedodonto.png',
      logoAditivo: '../../../../../../assets/app-assets/images/documentos-header/unimedodontoitens-header.png',
      logoInclusaoDependente:
        '../../../../../../assets/app-assets/images/documentos-header/unimed-ondonto-inclusao-dependente.png',
      tipo: TipoProduto_E_OperadoraEnum.UNIMED_ODONTO,
    },
  ],
  [
    TipoProduto_E_OperadoraEnum.UNIMEDFESP_SAUDE,
    {
      nome: ' UNIMED FESP',
      cnpj: '43643139000166',
      registroAns: '319996',
      site: 'http://www.unimed.coop.br',
      telefone: '0800-772-3030',
      logo: '../../../../../../assets/app-assets/images/logos-empresas/unimedfesp-preto-branco.png',
      logoAditivoUDEMO: '../../../../../../assets/app-assets/images/documentos-header/geia-udemo.png',
      logoAditivo: '../../../../../../assets/app-assets/images/documentos-header/aditivo-reducao-de-carencia.png',
      logoInclusaoDependente:
        '../../../../../../assets/app-assets/images/documentos-header/unimed-fesp-inclusao-dependente.png',
      logoInclusaoDependenteUdemo:
        '../../../../../../assets/app-assets/images/documentos-header/udemo-inclusao-dependente.png',
    },
  ],
  [
    TipoProduto_E_OperadoraEnum.MEDSENIOR,
    {
      nome: 'MEDSENIOR',
      cnpj: '31466949000105',
      registroAns: '33.561-4',
      site: 'https://medsenior.com.br/',
      telefone: '1340',
      logo: '../../../../../../assets/app-assets/images/logos-empresas/medsenior.png',
      logoAditivo: '../../../../../../assets/app-assets/images/documentos-header/med-senior-header-completo.png',
      logoInclusaoDependente:
        '../../../../../../assets/app-assets/images/documentos-header/med-senior-header-completo.png',
      logoInclusaoDependenteUdemo:
        '../../../../../../assets/app-assets/images/documentos-header/med-senior-header-completo.png',
    },
  ],
]);
// Mapas de busca reversa
const cnpjToEnum = new Map<string, TipoProduto_E_OperadoraEnum>();
const ansToEnum = new Map<string, TipoProduto_E_OperadoraEnum>();

// Popula os mapas de busca reversa
operadorasData.forEach((data, enumValue) => {
  cnpjToEnum.set(data.cnpj, enumValue);
  ansToEnum.set(data.registroAns, enumValue);
});

const descricao = new Map<TipoProduto_E_OperadoraEnum, string>([
  [TipoProduto_E_OperadoraEnum.SAUDE, 'saude'],
  [TipoProduto_E_OperadoraEnum.UNIMEDFESP_SAUDE, 'unimed Fesp'],
  [TipoProduto_E_OperadoraEnum.ODONTO, 'odonto'],
  [TipoProduto_E_OperadoraEnum.UNIODONTO, 'uniOdonto'],
  [TipoProduto_E_OperadoraEnum.ODONTOPREV, 'odontoPrev'],
  [TipoProduto_E_OperadoraEnum.UNIMED_ODONTO, 'unimed Odonto'],
  [TipoProduto_E_OperadoraEnum.MEDSENIOR, 'MedSênior'],
]);

export class TipoProduto_E_OperadoraComponent {
  static getOperadoraData(valor: TipoProduto_E_OperadoraEnum): any | undefined {
    return operadorasData.get(valor);
  }

  // Método para buscar por CNPJ
  static getByCnpj(cnpj: string, operadora?: any): any | undefined {
    const enumValue = cnpjToEnum.get(cnpj);
    return enumValue ? operadorasData.get(enumValue) : undefined;
  }

  // Método para buscar por ANS
  static getByAns(registroAns: string): any | undefined {
    const enumValue = ansToEnum.get(registroAns);
    return enumValue ? operadorasData.get(enumValue) : undefined;
  }

  // 🔹  Listas separadas por categoria
  private static tiposOdonto: TipoProduto_E_OperadoraEnum[] = [
    TipoProduto_E_OperadoraEnum.ODONTO,
    TipoProduto_E_OperadoraEnum.UNIODONTO,
    TipoProduto_E_OperadoraEnum.ODONTOPREV,
    TipoProduto_E_OperadoraEnum.UNIMED_ODONTO,
  ];

  private static tiposSaude: TipoProduto_E_OperadoraEnum[] = [
    TipoProduto_E_OperadoraEnum.SAUDE,
    TipoProduto_E_OperadoraEnum.UNIMEDFESP_SAUDE,
    TipoProduto_E_OperadoraEnum.UDEMO_SAUDE,
    TipoProduto_E_OperadoraEnum.MEDSENIOR,
  ];

  /** Retorna descrição amigável do tipo */
  static getDescricao(valor: TipoProduto_E_OperadoraEnum): string {
    return descricao.get(valor) || '';
  }

  /** Retorna lista de todos os tipos com descrição */
  static getAll(): {valor: TipoProduto_E_OperadoraEnum; descricao: string}[] {
    return Array.from(descricao.entries()).map(([valor, descricao]) => ({
      valor,
      descricao,
    }));
  }

  static isOdonto(tipo?: TipoProduto_E_OperadoraEnum): boolean {
    return !!tipo && this.tiposOdonto.includes(tipo);
  }

  static isSaude(tipo?: TipoProduto_E_OperadoraEnum): boolean {
    return !!tipo && this.tiposSaude.includes(tipo);
  }
}
